import script from "./ModuleSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuleSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ModuleSidebar.vue?vue&type=style&index=0&id=17a5630c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17a5630c"]])

export default __exports__